import React from "react";
import "../styles/components/LoadingScreen.css"

/**
 * ฟูลสกรีนโหลดดิ้ง (Bootstrap 5)
 * - มี aria-live เพื่อให้โปรแกรมอ่านหน้าจอบอกสถานะได้
 * - ใช้คลาส .fade-in เพื่อให้ค่อย ๆ ปรากฏ
 */
export default function LoadingScreen({ label = "กำลังตรวจสอบสิทธิ์…" }) {
  return (
    <div className="loading-screen fade-in" role="status" aria-live="polite">
      <div className="text-center">
        <div className="spinner-border mb-3" role="status" aria-hidden="true" />
        <div className="small text-muted">{label}</div>
      </div>
    </div>
  );
}
